import React, { useState } from "react";
import Calendar from 'react-calendar';
import { render } from "react-dom";
import 'react-calendar/dist/Calendar.css';
import { differenceInCalendarDays } from "date-fns";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { dateFromString } from "./date";

const hideOnPopperBlur = {
	name: 'hideOnPopperBlur',
	defaultValue: true,
	fn(instance) {
		return {
			onCreate() {
				instance.popper.addEventListener('focusout', (event) => {
					if (
						instance.props.hideOnPopperBlur &&
						event.relatedTarget &&
						!instance.popper.contains(event.relatedTarget)
					) {
						instance.hide();
					}
				});
			},
		};
	},
};

function isSameDay(itemDateStr, iterationDate) {
	const itemDate = dateFromString(itemDateStr);
	return differenceInCalendarDays(itemDate, iterationDate) === 0;
}

function isCurrentMonth(date) {
	const today = new Date();
	return date.getMonth() === today.getMonth();
}

const calendarLists = document.querySelectorAll('.react-root');
let unfilteredItems = [];
let items = [];

calendarLists.forEach(list => {
	if ('true' === list.getAttribute('data-mounted')) {
		return;
	}
	// eslint-disable-next-line prefer-const
	unfilteredItems = window[ list.getAttribute('data-list-item-var-name') ].slice();
	items = unfilteredItems.filter((item => item.type === "Veranstaltung"));
	items.forEach(object => {
		// we need to duplicate entries with a different start- and enddate so they appear twice in the calendar.
		// we then set dateFrom: object.dateTo for the second entry. later only dateFrom is used for filtering.
		if ((object.dateFrom !== "" && object.dateTo !== "") && (object.dateFrom !== object.dateTo)) {
			items.push({
				guid: object.guid,
				type: object.type,
				headline: object.headline,
				text: object.text,
				imgUrl: object.imgUrl,
				url: object.url,
				dateFrom: object.dateTo,
				keywords: object.keywords,
			});
		}

		// editors can pass a comma separated list of additional dates for which we also create new entries
		if (object.additionalDates) {
			const additionalDatesArray = object.additionalDates.split(',').map(dateStr => dateStr.trim());
			additionalDatesArray.forEach(entry => {
				if (entry !== object.dateFrom && entry !== object.dateTo) {
					items.push({
						guid: object.guid,
						type: object.type,
						headline: object.headline,
						text: object.text,
						imgUrl: object.imgUrl,
						url: object.url,
						dateFrom: entry,
						keywords: object.keywords,
					});
				}
			});
		}
	});
});

function tileClassname({ date, view }) {
	// Add class to tiles in month view only
	if (view === 'month') {
		const allItemsForTheDay = [];
		items.forEach(item => {
			if (isSameDay(item.dateFrom, date)) {
				allItemsForTheDay.push(item);
			}
		});
		// Check if a date React-Calendar wants to check is on the list of dates to add class to
		if (allItemsForTheDay.length === 1) {
			return 'day-with-event';
		} else if (allItemsForTheDay.length >= 1) {
			return 'day-with-event multiple-days';
		}
	}
}

function tileDisabled({ date, view }) {
	// Disable tiles in month view only
	if (view === 'month') {
		if (! items.find(dDate => isSameDay(dDate.dateFrom, date)) || ! isCurrentMonth(date)) {
			// Check if a date React-Calendar wants to check is on the list of disabled dates
			return date;
		}
	}
}

function tileContent({ date, view }) {
	// Add class to tiles in month view only
	if (view === 'month') {
		// Check if a date React-Calendar wants to check is on the list of dates to add class to
		const allItemsForTheDay = [];
		items.forEach(item => {
			if (isSameDay(item.dateFrom, date)) {
				allItemsForTheDay.push(item);
			}
		});
		if (allItemsForTheDay.length === 1) {
			// eslint-disable-next-line jsx-a11y/anchor-has-content
			return <a className="link-url" tabIndex={ 0 } href={ allItemsForTheDay[ 0 ].url } aria-label={ allItemsForTheDay[ 0 ].dateFrom + ' ' + allItemsForTheDay[ 0 ].headline }></a>;
		} else if (allItemsForTheDay.length > 1) {
			const multipleItems = [];
			allItemsForTheDay.forEach(item => {
				multipleItems.push(<a href={ item.url } aria-label={ item.headline }>{ item.headline }</a>);
			});
			return <Tippy content={ multipleItems } interactive={ true } trigger={ 'click focus' } plugins={ hideOnPopperBlur }>
				<button type={ "button" } className="link-url" aria-label={ 'Termine für ' + allItemsForTheDay[ 0 ].dateFrom } tabIndex={ 0 } ></button>
			</Tippy>;
		}
	}
}

function onActiveStartDateChange({ action, activeStartDate }) {
	if (action === 'prev' || action === 'next') {
		removeTabIndex();
		tileDisabled(activeStartDate);
	}
}

function onClickDay() {
	removeTabIndex();
}

function removeTabIndex() {
	const allDays = document.querySelectorAll('.day-with-event');
	const arr = Array.from(allDays);
	arr.forEach(function(item) {
		item.setAttribute('tabindex', '-1');
		item.removeAttribute('disabled');
	});
}

function ReactCalendar() {
	const [ value, onChange ] = useState(new Date());
	return (
		<div className="reactCalendar">
			<div className="reactCalendar__container">
				<main className="reactCalendar__container__content">
					<Calendar
						onActiveStartDateChange={ onActiveStartDateChange }
						onClickDay={ onClickDay }
						tileContent={ tileContent }
						onChange={ onChange }
						showWeekNumbers
						value={ value }
						tileClassName={ tileClassname }
						tileDisabled={ tileDisabled }
						nextAriaLabel={ 'Nächster Monat' }
						next2AriaLabel={ 'Nächstes Jahr' }
						prevAriaLabel={ 'Letzter Monat' }
						prev2AriaLabel={ 'Letztes Jahr' }
						showNeighboringMonth={ false }
					/>
				</main>
			</div>
		</div>
	);
}

if (document.getElementById('react-root')) {
	render(<ReactCalendar />, document.getElementById('react-root'));
	removeTabIndex();
}
